import React, {
  useCallback,
  useEffect,
  useState,
  useContext,
  useMemo,
  useRef,
} from "react";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import {
  ModalContainer,
  HeaderClose,
} from "../../../styled/web-map/market-share/MarketShare.styled";
import { IconWrapper } from "../../../styled/Tooltip.styled";
import ScatterModal from "./ChartModal";
import {
  CommonPieChart,
  CommonInfiniteScrollTable,
  CommonTitleBar,
  CommonScatterChart,
  CommonTimeLineChart,
  CommonTableTooltip,
  StyleTooltip,
} from "../../common";
import { CircularProgress, Grid } from "@mui/material";
import { WebMapContext } from "../../../../pages/sections/web-map/WebMapGoogleMap";
import {
  getOperatorMarketShareTableData,
  getOperatorNationMarketSharePieData,
  getOperatorMarketShareScatterData,
  getOperatorMSTableTooltipData,
  getOperatorMarketShareTrendsData,
  getOperatorMSGeohashData,
  getNationAvailabilityData
} from "../../../../services/api/marketShare.api";
import {
  ADM_LVL_NAME_MAP
} from "../../../../constants/Data";
import {
  capitalizeFirstLetter,
  convertArrayToStringWithDelimeter,
  formatDecimalPoints,
  calculateArrayAvg
} from "../../../../utils/helper";
import Typography from "@mui/material/Typography";
import CommonTypeTabsGroup from "../../common/CommonTypeTabsGroup";
import BasicDatePicker from "../../common/BasicDatePicker";
import { shouldAddToQuery } from "../../../../helpers/webMap";
import Papa from "papaparse";
import dayjs from "dayjs";
import styled from "styled-components";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Divider from "@mui/material/Divider";
import { LoadMapContext } from "../../../../pages/sections/web-map/LoadWebMap";
import { getAllDistinctWithCount } from "../../../../services/api/filterService";
import { adminLevelToAdm } from "../../../../constants/WebMapApi";
import { sortByReference } from "../../../../helpers/fuctionHelpers";
import { DATA_ORDERS } from "../../../../constants/WebMap";
import { AiOutlineClear } from "react-icons/ai";
import { getUniqueGeohashes } from "../../../../utils/webMapApiHelper";

const ColorDot = ({ color, borderColor, label }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      marginRight: "8px",
      marginLeft: "8px",
    }}
  >
    <div
      style={{
        width: "15px",
        height: "15px",
        borderRadius: "50%",
        backgroundColor: color, // Use backgroundColor prop
        border: `2px solid ${borderColor}`, // Use borderColor prop
        marginRight: "8px",
        marginLeft: "8px",
      }}
    />
    <Typography style={{ fontSize: "12px" }} variant="body1">
      {label} {/* Use label prop */}
    </Typography>
  </div>
);
const CustomDiv = styled.div`
  height: 24.5vh; /* Default height */

  @media (min-width: 1900px) {
    height: 26.8vh; /* Height for screens with a width of 2480px or larger */
  }
`;

const OprtMSModal = ({
  isOpen,
  setIsOpen,
  borderLvlValue,
  connectionValue,
  selectedOperatorSupply,
  range,
  action,
  quad = [],
  setSavedRows,
  savedRows,
  setSavedGeoRows,
  savedGeoRows,
  msRanks,
  apiTrigger,
  setVisualizePriority,
  geoHashTableColumns,
  filterColumnsByLevel,
  filteredColumns,
  geohashfilteredColumns,
  setGeohashfilteredColumns,
  msSort,
  setMsSort,
  geoMsSort,
  setGeoMsSort,
  quadCount,
  permittedOperators
}) => {
  // status values
  const { appliedFilters, operatorDetails, msTableColorConfig, mapPlacement, globalConfig, setMsGeohashOnMap, msConfig } =
    useContext(WebMapContext);
  const parentRef = useRef(null);
  const { mapView, showMsModal, setIsOpMsTableOpen } = useContext(LoadMapContext);
  const { countryCode, year, quarter, level, levelVal } = appliedFilters;

  const geohashCSVColumns = geoHashTableColumns
    .filter((item) => item.colSpan !== 2)
    .map((item) => item.label);
  const devisionalCSVColumns = filteredColumns
    .filter((item) => item.colSpan !== 2)
    .map((item) => item.label);

  const getQuarterStartDate = useCallback(() => {
    switch (quarter) {
      case "Q1":
        return dayjs(`${year}-01-01`).format("YYYY-MM-DD");
      case "Q2":
        return dayjs(`${year}-04-01`).format("YYYY-MM-DD");
      case "Q3":
        return dayjs(`${year}-07-01`).format("YYYY-MM-DD");
      case "Q4":
        return dayjs(`${year}-10-01`).format("YYYY-MM-DD");
      default:
        return dayjs();
    }
  }, [year, quarter]);

  const getQuarterEndDate = useCallback(() => {
    switch (quarter) {
      case "Q1":
        return dayjs(`${year}-03-31`).format("YYYY-MM-DD");
      case "Q2":
        return dayjs(`${year}-06-30`).format("YYYY-MM-DD");
      case "Q3":
        return dayjs(`${year}-09-30`).format("YYYY-MM-DD");
      case "Q4":
        return dayjs(`${year}-12-31`).format("YYYY-MM-DD");
      default:
        return dayjs();
    }
  }, [year, quarter]);

  const MS_GEOHASH_MARGINS = {};

  if (msTableColorConfig && msTableColorConfig.length) {
    msTableColorConfig.forEach((config) => {
      if (
        config.data &&
        config.data.length &&
        config.sectionType === "MS_GEO_TABLE"
      ) {
        config.data.forEach((item) => {
          MS_GEOHASH_MARGINS[item.type] = parseInt(item.colorValue);
        });
      }
    });
  }

  const [operatorTableData, setOperatorTableData] = useState([]);
  const [nationPieData, setNationPieData] = useState([]);
  const [scatterData, setScatterData] = useState([]);
  const [operatorData, setOperatorData] = useState([]);
  const [yRefLine, setYRefLine] = useState();
  const [diviTableInitFetch, setDiviTableInitFetch] = useState(false);
  const [diviTableSelectAll, setdiviTableSelectAll] = useState(false);
  const [openTableTooltip, setOpenTableTooltip] = useState(false);
  const [optTableTooltipData, setOptTableTooltipData] = useState({});
  const [msAvailability, setMSAvailability] = useState(null);
  const [isModalOpen, setisModalOpen] = useState(false);
  const [trendsData, setTrendsData] = useState([]);
  const [trendTabs, setTrendTabs] = useState([]);
  const [selectedTab, setSelectedTab] = useState("Daily");
  const [geohashTableData, setGeohashTableData] = useState([]);
  const [geoTableInitFetch, setGeoTableInitFetch] = useState(false);
  const [geoTableSelectAll, setGeoTableSelectAll] = useState(false);
  const [selectedRowIdx, setSelectedRowIdx] = useState(0);
  const [customGeoPage, setCustomGeoPage] = useState(1);
  const [geoHashloading, setGeoHashLoading] = useState(false);
  const [adm3Selected, setAdm3Selected] = useState(false);
  const [maxSizeExeeds, setMaxSizeExceeds] = useState(false);
  const [showErrorMsg, setShowErrorMSg] = useState(false);
  const [isVisibleOverlay, setVisibleOverlay] = useState(false)
  const [isExpanded, setIsExpanded] = useState(false);
  const [parentHeight, setParentHeight] = useState(0);
  const [parentWidth, setParentWidth] = useState(0);
  const [startDate, setStartDate] = useState(getQuarterStartDate());
  const [endDate, setEndDate] = useState(getQuarterEndDate());
  const [geohashFetchTrigger, setGeohashFetchTrigger] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [initialGeohashes, setInitialGeohashes] = useState([]);
  const [selectedRows, setSelectedRows] = useState(savedRows);
  const [selectedGeoRows, setSelectedGeoRows] = useState(savedGeoRows);
  const [diviTableClear, setDiviTableClear] = useState(false); // manually deselect all selected rows
  const [geoTableClear, setGeoTableClear] = useState(false); // manually deselect all selected rows

  useEffect(() => {
    if (selectedRows.length) {
      setGeohashFetchTrigger(prevValue => (prevValue === 0 ? 1 : 0));
    }
  }, [JSON.stringify(selectedRows)])

  useEffect(() => {
    if (parentRef.current) {
      const height = parentRef.current.clientHeight;
      const width = parentRef.current.clientWidth;
      setParentWidth(width);
      setParentHeight(height);
    }
  }, []);

  useEffect(() => {
    if (mapView !== null) {
      setIsOpen(mapPlacement === "right" ? showMsModal.rightModal : showMsModal.leftModal)
    }
  }, [showMsModal]);

  useEffect(() => {
    if (operatorTableData.length){
      setSelectedRows([]); // reset selected rows
      fetchCtAvailability(true);
    } 
    if (geohashTableData.length) setSelectedGeoRows([]);
    setdiviTableSelectAll(false);
    setGeoTableSelectAll(false);
  }, [
    countryCode,
    year,
    quarter,
    level, levelVal,
    borderLvlValue, connectionValue,
    selectedOperatorSupply,
    range, msRanks,
    action, quad
  ]);

  const exportDataToCSV = (DATA, name) => {
    const csv = Papa.unparse(DATA);
    const csvBlob = new Blob([csv], { type: "text/csv" });
    const csvUrl = URL.createObjectURL(csvBlob);
    const link = document.createElement("a");
    link.href = csvUrl;
    link.download = `${name}.csv`;
    link.click();
    URL.revokeObjectURL(csvUrl);
  };

  const fetchCSVData = async (page = 1, accumulatedData = []) => {
    try {
      const addRanks = shouldAddToQuery(msRanks);
      const addActions = shouldAddToQuery(action);
      const quadFilters = quad
        .filter((x) => x.isChecked)
        .map((x) => x.filterName);
      const checkedQuads = convertArrayToStringWithDelimeter(quadFilters, "_");
      const { data = [] } = await getOperatorMarketShareTableData(
        {
          country: countryCode,
          quarter: `${quarter} ${year}`,
          borderLvl: borderLvlValue,
          connectionType: connectionValue,
          ...(appliedFilters?.adminLevel1 && { adminLevel1: appliedFilters?.adminLevel1 }),
          ...(appliedFilters?.adminLevel2 && { adminLevel2: appliedFilters?.adminLevel2 }),
          ...(appliedFilters?.adminLevel3 && { adminLevel3: appliedFilters?.adminLevel3 }),
          operator: selectedOperatorSupply,
          msRangeFrom: range[0],
          msRangeTo: range[1],
          ...(addRanks && {
            rank: convertArrayToStringWithDelimeter(addRanks, "_"),
          }),
          ...(addActions && {
            action: convertArrayToStringWithDelimeter(addActions, "_"),
          }),
          quad: checkedQuads || "_",
        },
        30000,
        page
      );
      // Accumulate data from each page
      const updatedData = [...accumulatedData, ...data];
      if (data.length > 0) {
        fetchCSVData(page + 1, updatedData);
      } else {
        const transformedData = getCSVData(updatedData);
        exportDataToCSV(
          { fields: devisionalCSVColumns, data: transformedData },
          "Operator"
        );
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const fetchGeohashCSVData = async (page = 1, accumulatedData = []) => {
    if (adm3Selected) {
      const pageSize = 20000;
      const csvFileSize = 3;
      try {
        setGeoHashLoading(true);
        const res = await geoHashTableFetchAPI(selectedRowIdx, page, "adminLevel1", "asc", pageSize);
        // Accumulate data from each page
        const updatedData = [...accumulatedData, ...res];
        let dataSize = new Blob([updatedData]).size / (1024 * 1024);
        if (res.length === pageSize && dataSize < csvFileSize) {
          fetchGeohashCSVData(page + 1, updatedData);
        } else {
          const transformedData = getGeohashCSVData(updatedData);
          exportDataToCSV(
            { fields: geohashCSVColumns, data: transformedData },
            "Geohash"
          );
          if (dataSize > csvFileSize) {
            setMaxSizeExceeds(true);
            setTimeout(() => {
              setMaxSizeExceeds(false);
            }, 10000);
          }
          setGeoHashLoading(false);
        }
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    } else {
      setShowErrorMSg(true);
    }
  };

  const handleTabChange = (type) => {
    setSelectedTab(type);
    OperatorMarketShareTrendsFetch(
      borderLvlValue,
      connectionValue,
      selectedOperatorSupply,
      type,
      startDate,
      endDate
    );
  };

  const handleDateChange = (startDate, endDate) => {
    setStartDate(startDate);
    setEndDate(endDate);
    OperatorMarketShareTrendsFetch(
      borderLvlValue,
      connectionValue,
      selectedOperatorSupply,
      selectedTab,
      startDate,
      endDate
    );
  };

  const onClickDownload = () => {
    selectedRows.length ? fetchSelectedCSVData() : fetchCSVData();
  };

  const onClickGeohashDownload = () => {
    selectedGeoRows.length
      ? fetchSelectedGeoHashCSVData()
      : fetchGeohashCSVData();
  };

  const onChangeGeohashColumns = (status = false, isSort = false) => {
    let columns = []
    if (isSort) {
      columns = geohashfilteredColumns.map(item => {
        if (item.field === "adm1" || item.field === "adm2" || item.field === "adm3") {
          return { ...item, hideSort: status };
        }
        return item;
      });
    } else {
      columns = filterColumnsByLevel(
        geoHashTableColumns,
        borderLvlValue
      );
    }
    setGeohashfilteredColumns(columns)
  }


  const OperatorNationMarketSharePieFetch = useCallback(
    async (connectionType) => {
      const res = await getOperatorNationMarketSharePieData({
        country: countryCode,
        quarter: `${quarter} ${year}`, //!replace Q3
        connectionType: connectionType, //! 4G
      });
      const modifiedArray = res.data.map((item) => {
        const matchingObj = permittedOperators.find(
          (obj) => obj.operator === item.name
        );
        if (matchingObj) {
          return {
            ...item,
            op: item.name,
            name: matchingObj.name,
            color: matchingObj.isAnonymized ? "#B4B4B4" : matchingObj.color,
          };
        }
        return item;
      });
      setNationPieData(modifiedArray);
      setOpenTableTooltip(false);
      return res.data;
    },
    [countryCode, year, quarter, selectedOperatorSupply]
  );

  const fetchCtAvailability = useCallback(
    async (isNation = true, dataArr = []) => {
      if(isNation){
        const res = await getNationAvailabilityData({
              country: countryCode,
              quarter: `${quarter} ${year}`,
              connectionType: connectionValue,
              ...(appliedFilters?.adminLevel1 && { adminLevel1 :appliedFilters?.adminLevel1  }),
              ...(appliedFilters?.adminLevel2 && { adminLevel2 :appliedFilters?.adminLevel2  }),
              ...(appliedFilters?.adminLevel3 && { adminLevel3 :appliedFilters?.adminLevel3  }),
              borderLvl: borderLvlValue,
              operator: selectedOperatorSupply,
        });
        const sum = res?.data?.[0]?.[`${connectionValue}`] ? parseFloat(res?.data[0][`${connectionValue}`]).toFixed(2) : null
        setMSAvailability(sum)

      }else{
        const arrAvg = calculateArrayAvg(dataArr, connectionValue )
        setMSAvailability(arrAvg)
      } 
    },
    [appliedFilters, connectionValue, borderLvlValue,  selectedOperatorSupply]
  );

  const OperatorMarketShareScatterFetch = useCallback(async () => {
    const addRanks = shouldAddToQuery(msRanks);
    const addActions = shouldAddToQuery(action);
    const quadFilters = quad
      .filter((x) => x.isChecked)
      .map((x) => x.filterName);
    const checkedQuads = convertArrayToStringWithDelimeter(quadFilters, "_");
    const res = await getOperatorMarketShareScatterData({
      country: countryCode,
      quarter: `${quarter} ${year}`,
      ...(appliedFilters?.adminLevel1 && { adminLevel1: appliedFilters?.adminLevel1 }),
      ...(appliedFilters?.adminLevel2 && { adminLevel2: appliedFilters?.adminLevel2 }),
      ...(appliedFilters?.adminLevel3 && { adminLevel3: appliedFilters?.adminLevel3 }),
      borderLvl: borderLvlValue,
      connectionType: connectionValue,
      operator: selectedOperatorSupply,
      msRangeFrom: range[0],
      msRangeTo: range[1],
      ...(addRanks && {
        rank: convertArrayToStringWithDelimeter(addRanks, "_"),
      }),
      ...(addActions && {
        action: convertArrayToStringWithDelimeter(addActions, "_"),
      }),
      quad: checkedQuads || "_",
    });
    if (res.data && res.data.length === 1 && res.data[0].x === 0 && res.data[0].y === 0) {
      setScatterData([]);
    } else {
      setScatterData(res.data);
    }

    return res.data;
  }, [
    appliedFilters,
    borderLvlValue,
    connectionValue,
    selectedOperatorSupply,
    range,
    action,
    quad,
    msRanks
  ]);

  const OperatorMarketShareTrendsFetch = useCallback(
    async (
      borderLvlValue,
      connectionValue,
      selectedOperatorSupply,
      trendType,
      startDate,
      endDate,
      fetchTabs = false
    ) => {
      let tab = trendType;
      if (fetchTabs) {
        const { data } = await getAllDistinctWithCount(
          {
            countryCode,
            year,
            quarter,
            column: "type",
            table: "market_share_trend",
          },
          {
            params: {
              filtered: `lvl:${borderLvlValue},op:${selectedOperatorSupply},ct:${connectionValue}${level ? `,${adminLevelToAdm[level]}:${levelVal}` : ''}`,
            },
            hideLoader: true
          }
        );
        const filtersList = data.map((x) => ({
          label: x._id,
          value: x._id,
          disabled: x.count <= 0,
        }));
        const tabsArr = sortByReference(filtersList, DATA_ORDERS.TREND_TABS, "label");
        setTrendTabs(tabsArr);
        const isTabInArr = tabsArr.find(x => x.value === tab);
        if (!isTabInArr || isTabInArr.disabled) {
          tab = tabsArr.find(x => !x.disabled)?.value;
          setSelectedTab(tab);
        } 
      }
      setVisibleOverlay(false);
      const selectedAreas = selectedRows.length ? [...new Set(selectedRows)] : [];

      let adminLevel1 = appliedFilters.adminLevel1 ? [appliedFilters.adminLevel1] : null;
      let adminLevel2 = appliedFilters.adminLevel2 ? [appliedFilters.adminLevel2] : null;
      let adminLevel3 = appliedFilters.adminLevel3 ? [appliedFilters.adminLevel3] : null;
      const adminLevels = ['ADM1', 'ADM2', 'ADM3'];

      if (selectedAreas.length > 0) {
        [adminLevel1, adminLevel2, adminLevel3] = adminLevels.map(lvl =>
          selectedAreas.map(area => area[lvl.toLowerCase()] || null)
        );
      }

      // setTrendsData([]);
      const res = await getOperatorMarketShareTrendsData({
        country: countryCode,
        quarter: `${quarter} ${year}`,
        ...(adminLevel1?.length && { adminLevel1 }),
        ...(adminLevel2?.length && { adminLevel2 }),
        ...(adminLevel3?.length && { adminLevel3 }),
        borderLvl: borderLvlValue,
        connectionType: connectionValue,
        operator: selectedOperatorSupply,
        start: startDate,
        end: endDate,
        type: tab,
      });
      setTrendsData(res.data);
      setIsLoading(false);
      if (!res.data || !res.data.length) setVisibleOverlay(true);
      else setVisibleOverlay(false);
      return res.data;
    },
    [appliedFilters, selectedRows]
  );

  const findValueForOp = (array, op) => {
    const item = array.find((obj) => obj.op === op);
    return item ? item.value : null;
  };

  const OperatorMarketShareFetch = useCallback(
    async (page = 1, limit = 15, sortBy = msSort.sortBy, sortOrder = msSort.sortOrder, sortFetch = false) => {
      setOpenTableTooltip(false);
      const addRanks = shouldAddToQuery(msRanks);
      const addActions = shouldAddToQuery(action);
      const quadFilters = quad
        .filter((x) => x.isChecked)
        .map((x) => x.filterName);
      const checkedQuads = convertArrayToStringWithDelimeter(quadFilters, "_");
      let { data = [] } = await getOperatorMarketShareTableData(
        {
          country: countryCode,
          quarter: `${quarter} ${year}`,
          borderLvl: borderLvlValue,
          connectionType: connectionValue,
          ...(appliedFilters?.adminLevel1 && { adminLevel1: appliedFilters?.adminLevel1 }),
          ...(appliedFilters?.adminLevel2 && { adminLevel2: appliedFilters?.adminLevel2 }),
          ...(appliedFilters?.adminLevel3 && { adminLevel3: appliedFilters?.adminLevel3 }),
          operator: selectedOperatorSupply,
          msRangeFrom: range[0],
          msRangeTo: range[1],
          ...(addRanks && {
            rank: convertArrayToStringWithDelimeter(addRanks, "_"),
          }),
          ...(addActions && {
            action: convertArrayToStringWithDelimeter(addActions, "_"),
          }),
          quad: checkedQuads || "_",
          sortBy: sortBy,
          sortOrder: sortOrder
        },
        limit,
        page
      );
      data = data?.map(({ quad, ...obj }) => ({
        ...obj,
        quad: quad ? updateMSQuadName(quad) : quad
      }));
      if (diviTableSelectAll && !sortFetch) {
        data.forEach((itm) => {
          itm.selected = true;
        });
        if (!diviTableInitFetch){
          setSelectedRows([...selectedRows, ...data]);
          fetchCtAvailability(false, [...selectedRows, ...data])
        } 
      } else if (selectedRows.length > 0 && !sortFetch) {
        data.forEach((itm) => {
          const selected = selectedRows.some((x) => {
            // Check if the keys adm2 and adm3 exist in both objects
            const adm2Exists = "adm2" in x && "adm2" in itm;
            const adm3Exists = "adm3" in x && "adm3" in itm;
            if (
              x.adm1 === itm.adm1 &&
              (!adm2Exists || x.adm2 === itm.adm2) &&
              (!adm3Exists || x.adm3 === itm.adm3)
            ) {
              return true;
            }
          });
          itm.selected = selected;
        });
      }
      setOperatorTableData(data);
      if (diviTableInitFetch) setDiviTableInitFetch(false);
      return { data };
    },
    [
      diviTableInitFetch,
      appliedFilters,
      borderLvlValue,
      connectionValue,
      selectedOperatorSupply,
      range,
      action,
      quad,
      selectedRows,
      msRanks
    ]
  );

  const clearSelectedData = (tableName) => {
    if (tableName === "DiviTable") {
      const prevSelectedRows = [...selectedRows]
      if (prevSelectedRows.length) {
        onChangeGeohashColumns()
        setSelectedGeoRows([]);
        setGeoTableSelectAll(false);
        setGeoMsSort({ sortBy: geohashfilteredColumns[0].field, sortOrder: "asc" })
        setGeohashFetchTrigger(prevValue => (prevValue === 0 ? 1 : 0));

      }
      setdiviTableSelectAll(false);
      setSelectedRows([])
      fetchCtAvailability(true);
    } else {
      setGeoTableSelectAll(false)
      setSelectedGeoRows([])
    }
  }
  const fetchData = useCallback(async ({ page, sortBy, sortOrder, sortFetch }) => {
    setDiviTableInitFetch(false)
    return await OperatorMarketShareFetch(page, 15, sortBy, sortOrder, sortFetch);
  }, []);

  const geoHashTableFetchAPI = async (rowIdx, page, sortBy, sortOrder, limit = 15) => {
    const selectedAreas = selectedRows.length ? [...new Set(selectedRows)] : [];
    let adminLevel1 = appliedFilters.adminLevel1 || null;
    let adminLevel2 = appliedFilters.adminLevel2 || null;
    let adminLevel3 = appliedFilters.adminLevel3 || null;
    const adminLevels = ['ADM1', 'ADM2', 'ADM3'];

    if (selectedAreas.length > 0) {
      [adminLevel1, adminLevel2, adminLevel3] = adminLevels.map(lvl =>
        selectedAreas[rowIdx][lvl.toLowerCase()] || null
      );
    }
    const addActions = shouldAddToQuery(action);
    const quadFilters = quad
      .filter((x) => x.isChecked)
      .map((x) => x.filterName);
    const checkedQuads = convertArrayToStringWithDelimeter(quadFilters, "_");

    const sort = (sortBy === 'adm1' || sortBy === 'adm2' || sortBy === 'adm3') ? ADM_LVL_NAME_MAP[sortBy.toUpperCase()] : sortBy
    const response = await getOperatorMSGeohashData(
      {
        country: countryCode,
        quarter: `${quarter} ${year}`,
        connectionType: connectionValue,
        adminLevel1,
        adminLevel2,
        adminLevel3,
        operator: selectedOperatorSupply,
        ...(addActions && {
          action: convertArrayToStringWithDelimeter(addActions, "_"),
        }),
        quad: checkedQuads || "_",
        sortBy: sort,
        sortOrder
      },
      limit,
      page
    );
    const data = response?.data?.length
      ? response.data.map((obj) => {
        obj.geo_rsrp_type = obj.rsrp >= MS_GEOHASH_MARGINS.rsrp
          ? 1
          : 0;
        obj.geo_down_type = obj.download >= MS_GEOHASH_MARGINS.down
          ? 1
          : 0;
        obj.geo_up_type = obj.upload >= MS_GEOHASH_MARGINS.upload
          ? 1
          : 0;
        obj.quad = updateMSQuadName(obj.quad)
        return obj;
      })
      : [];
    return data;
  };

  const getCSVData = (data) => {
    const formatData = (data ?? []).map(({ quad, ...item }) => ({
      ...item,
      quad: updateMSQuadName(quad)
    }));
    const csvData = formatData.map((item) => {
      return (
        filteredColumns.filter((item) => item.colSpan !== 2).map((col) => {
          return item[col.field] || []
        })
      )
    })
    return csvData;
  };

  const getGeohashCSVData = (data) => {
    const updatedData = (data ?? []).map(({ quad, ...item }) => ({
      ...item,
      quad: quad ? updateMSQuadName(quad) : quad,
    }));
    return (
      updatedData?.map((item) => [
        item.adm1,
        item.adm2,
        item.adm3,
        item.geohash,
        item.d_score,
        item.rsrp,
        item.download,
        item.upload,
        item.sinr,
        item.rsrq,
        item.action,
        item.quad,
      ]) || []
    );
  };

  const fetchSelectedGeoHashCSVData = () => {
    if (adm3Selected) {
      const selectedAreas = selectedGeoRows.length
        ? [...new Set(selectedGeoRows)]
        : [];
      const transformedData = getGeohashCSVData(selectedAreas);
      exportDataToCSV(
        { fields: geohashCSVColumns, data: transformedData },
        "selectedGeoRows"
      );
    } else {
      setShowErrorMSg(true);
    }
  };

  const fetchSelectedCSVData = () => {
    const selectedAreas = selectedRows.length ? [...new Set(selectedRows)] : [];
    const transformedData = getCSVData(selectedAreas);
    exportDataToCSV(
      { fields: devisionalCSVColumns, data: transformedData },
      "SelectedOperator"
    );
  };

  const GeohashDataHandler = useCallback(
    async (page = 1, limit = 15, rowIdx = selectedRowIdx, isScroll = false, sortBy = geoMsSort.sortBy, sortOrder = geoMsSort.sortOrder, sortFetch = false) => {
      if (sortFetch) setInitialGeohashes([])
      setOpenTableTooltip(false);
      let data = [];
      let customPage = null;
      const selectedAreas = selectedRows.length
        ? [...new Set(selectedRows)]
        : [];
      onChangeGeohashColumns(selectedAreas.length ? true : false, true)

      if (selectedAreas.length) {
        // Fetch data for the current area based on the current page
        let initResponse = await geoHashTableFetchAPI(rowIdx, page, sortBy, sortOrder);

        while (
          initResponse?.length === 0 &&
          rowIdx + 1 < selectedAreas.length
        ) {
          rowIdx++;
          setSelectedRowIdx(rowIdx);
          initResponse = await geoHashTableFetchAPI(rowIdx, page, sortBy, sortOrder);
        }

        if (sortFetch) {
          customPage = 2
          setCustomGeoPage(2);
          data = initResponse;
        } else {
          if (initResponse?.length < limit) {
            // If there are more selected areas to fetch
            if (rowIdx + 1 < selectedAreas.length) {
              setSelectedRowIdx(rowIdx + 1);
              customPage = 2; // Custom reset page for the next area

              // Fetch data for the next area
              const response = await geoHashTableFetchAPI(rowIdx + 1, 1, sortBy, sortOrder);
              setCustomGeoPage(1);
              data = [...initResponse, ...response];
            } else {
              data = initResponse;
              customPage = 1;
              setCustomGeoPage(1);
            }
          } else {
            data = initResponse;
            if (!isScroll) setCustomGeoPage(2);
          }
        }

      } else {
        if (sortFetch) {
          setSelectedRowIdx(0);
          customPage = 2
        }
        const response = await geoHashTableFetchAPI(rowIdx, page, sortBy, sortOrder);
        setCustomGeoPage(2);
        data = response;
      }

      if (geoTableSelectAll && !sortFetch) {
        data.forEach((itm) => {
          itm.selected = true;
        });
        if (!geoTableInitFetch)
          setSelectedGeoRows([...selectedGeoRows, ...data]);
      } else if (selectedGeoRows.length > 0 && !sortFetch) {
        data.forEach((itm) => {
          const selected = selectedGeoRows.some((x) => {
            if (
              x.adm1 === itm.adm1 &&
              (x.adm2 === itm.adm2) &&
              (x.adm3 === itm.adm3) &&
              (x.geohash === itm.geohash)
            ) {
              return true;
            }
          });
          itm.selected = selected;
        });
      }
      setGeohashTableData(data);
      if (geoTableInitFetch) setGeoTableInitFetch(false);
      setInitialGeohashes(data);
      return { data, page: customPage };
    },
    [
      appliedFilters,
      borderLvlValue,
      connectionValue,
      selectedOperatorSupply,
      action,
      quad,
      selectedGeoRows,
      geoTableInitFetch,
      selectedRows,
      geoTableSelectAll
    ]
  );

  const fetchGeohashData = useCallback(async ({ page, sortBy, sortOrder, sortFetch }) => {
    if (sortFetch) {
      setGeoTableInitFetch(false);
      setInitialGeohashes([]);
    }
    let response = await GeohashDataHandler(page, 15, selectedRowIdx, true, sortBy, sortOrder, sortFetch);
    if (response?.data?.length > 0) response.data = getUniqueGeohashes(response.data); // sometimes geohash is duplicating
    sortFetch && page === 1 ? setInitialGeohashes(response.data) : setInitialGeohashes([...initialGeohashes, ...response.data]);
    return response;
  }, [selectedRowIdx]);

  const handleModalClose = () => {
    setisModalOpen(false);
  };

  const handleModalOpen = () => {
    setisModalOpen(true);
  };

  const getSidePanelWidth = useCallback(() => {
    const element = document.getElementsByClassName("web-map-side-panel");
    if (element && element.length) {
      const newWidth = mapPlacement === "left" ? element[0].offsetWidth : element[1].offsetWidth;
      return mapView === null ? `${newWidth + 24}px` : `${newWidth + 89}px`;
    }
  }, [mapView, mapPlacement]);

  useEffect(() => {
    if (countryCode && year && quarter && isOpen) {
      const opValue = findValueForOp(nationPieData, selectedOperatorSupply);
      setDiviTableInitFetch(true);
      setYRefLine(opValue);
      OperatorMarketShareScatterFetch();
    }
  }, [
    JSON.stringify(appliedFilters),
    isOpen,
    JSON.stringify(nationPieData),
    apiTrigger,
  ]);

  useEffect(() => {
    if (borderLvlValue === "ADM3") {
      setAdm3Selected(true);
      setShowErrorMSg(false);
    } else {
      setAdm3Selected(false);
      setShowErrorMSg(false);
    }
    fetchCtAvailability(true);
    setDiviTableInitFetch(true);
    setGeohashFetchTrigger(prevValue => (prevValue === 0 ? 1 : 0));
    onChangeGeohashColumns()
  }, [borderLvlValue]);

  useEffect(() => {
    if (countryCode && year && quarter && isOpen) {
      OperatorMarketShareTrendsFetch(
        borderLvlValue,
        connectionValue,
        selectedOperatorSupply,
        selectedTab,
        startDate,
        endDate,
        true
      );
    }
  }, [
    isOpen,
    JSON.stringify(appliedFilters),
    apiTrigger,
    JSON.stringify(selectedRows)
  ]);

  useEffect(() => {
    if (!operatorData.length && operatorDetails.length && isOpen) {
      const mnoOperators = operatorDetails.filter(
        (operator) => operator.type === "MNO"
      );
      setOperatorData(mnoOperators);
    }
  }, [isOpen, operatorData, operatorDetails]);

  useEffect(() => {
    if (operatorData.length && isOpen) {
      OperatorNationMarketSharePieFetch(connectionValue, operatorData);
    }
  }, [
    OperatorNationMarketSharePieFetch,
    connectionValue,
    isOpen,
    JSON.stringify(operatorData),
  ]);

  useEffect(() => {
    setDiviTableInitFetch(true);
    setdiviTableSelectAll(false);
    setOpenTableTooltip(false); // hide table tooltip
    fetchCtAvailability(true);
    if (quad.length > 0) OperatorMarketShareFetch();
    setGeohashFetchTrigger(prevValue => (prevValue === 0 ? 1 : 0));
  }, [JSON.stringify(appliedFilters), isOpen, apiTrigger]);

  useEffect(() => {
    // update geohash table
    if (isOpen) {
      setGeoTableInitFetch(true);
      setGeohashTableData([]);
      setSelectedRowIdx(0);
      setCustomGeoPage(1);
      GeohashDataHandler(1, 15, 0);
    }
  }, [geohashFetchTrigger]);

  const onClickRow = useCallback(
    async (e, selectedRow, tableRef) => {
      setOpenTableTooltip(false);
      const rowPosition = e.currentTarget;
      const res = await getOperatorMSTableTooltipData({
        country: countryCode,
        quarter: `${quarter} ${year}`,
        ...(selectedRow['adm1'] && { adminLevel1: selectedRow['adm1'] }),
        ...(selectedRow['adm2'] && { adminLevel2: selectedRow['adm2'] }),
        ...(selectedRow['adm3'] && { adminLevel3: selectedRow['adm3'] }),
        borderLvl: borderLvlValue,
        connectionType: connectionValue,
      });

      const operators = operatorDetails.filter(
        (operator) => operator.type === "MNO"
      );
      const modifiedArray = res.data?.opData.map((item) => {
        const matchingObj = permittedOperators.find((obj) => obj.operator === item.name);
        if (matchingObj) {
          return {
            ...item,
            op: item.name,
            name: matchingObj.name,
            color:  matchingObj.isAnonymized ? "#B4B4B4" : matchingObj.color,
          };
        }
        return item;
      });
      setOptTableTooltipData({
        data: modifiedArray,
        admData: res.data.admData,
        rowPosition: rowPosition,
        tablePosition: tableRef,
        selectedOptr: modifiedArray.find(
          ({ op }) => op === selectedOperatorSupply
        ),
      });
      setOpenTableTooltip(true);
    },
    [
      appliedFilters,
      borderLvlValue,
      connectionValue,
      operatorDetails
    ]
  );

  const onSelectRow = useCallback(
    (selectedRow) => {
      setOpenTableTooltip(false);
      onChangeGeohashColumns()
      setSelectedGeoRows([]);
      setGeoTableSelectAll(false);
      setGeoMsSort({ sortBy: geohashfilteredColumns[0].field, sortOrder: "asc" })
      const isSelected = selectedRow.selected; // is selected or deselect
      if (isSelected){
        setSelectedRows([...selectedRows, selectedRow]);
        fetchCtAvailability(false, [...selectedRows, selectedRow] )
      } else {
        const filtered = selectedRows.filter((x) => {
          // Check if the keys adm2 and adm3 exist in both objects
          const adm2Exists = "adm2" in x && "adm2" in selectedRow;
          const adm3Exists = "adm3" in x && "adm3" in selectedRow;
          if (
            x.adm1 === selectedRow.adm1 &&
            (!adm2Exists || x.adm2 === selectedRow.adm2) &&
            (!adm3Exists || x.adm3 === selectedRow.adm3)
          ) {
            return false;
          }
          return true;
        });
        setSelectedRows(filtered);
        filtered?.length ? fetchCtAvailability(false, filtered ) : fetchCtAvailability(true)

        if (filtered.length === 0) {
          setGeohashFetchTrigger(prevValue => (prevValue === 0 ? 1 : 0));
        }
      }
    },
    [JSON.stringify(selectedRows)]
  );

  const onSelectAll = useCallback(
    (rows = []) => {
      setOpenTableTooltip(false);
      setdiviTableSelectAll(!diviTableSelectAll);

      setSelectedRows([]);
      fetchCtAvailability(true);
      onChangeGeohashColumns()
      setSelectedGeoRows([]);
      setGeoTableSelectAll(false);
      setGeoMsSort({ sortBy: geohashfilteredColumns[0].field, sortOrder: "asc" })

      if (rows.length > 0) {
        setSelectedRows(rows);
        fetchCtAvailability(false, rows)
      } else {
        setSelectedRows([]);
        fetchCtAvailability(true);
        setGeohashFetchTrigger(prevValue => (prevValue === 0 ? 1 : 0));
      }
    },
    [diviTableSelectAll]
  );

  // geohash table related fucns
  const onSelectGeohashRow = useCallback(
    (selectedRow) => {
      setShowErrorMSg(false);
      setOpenTableTooltip(false);
      const isSelected = selectedRow.selected; // is selected or deselect
      if (isSelected) setSelectedGeoRows([...selectedGeoRows, selectedRow]);
      else {
        const filtered = selectedGeoRows.filter((x) => {
          // Check if the keys adm2 and adm3 exist in both objects
          const adm2Exists = "adm2" in x && "adm2" in selectedRow;
          const adm3Exists = "adm3" in x && "adm3" in selectedRow;
          const geohashExists = "geohash" in x && "geohash" in selectedRow;
          if (
            x.adm1 === selectedRow.adm1 &&
            (!adm2Exists || x.adm2 === selectedRow.adm2) &&
            (!adm3Exists || x.adm3 === selectedRow.adm3) &&
            (!geohashExists || x.geohash === selectedRow.geohash)
          ) {
            return false;
          }
          return true;
        });
        setSelectedGeoRows(filtered);
      }
    },
    [selectedGeoRows]
  );

  const onSelectGeohashAll = useCallback(
    (rows = []) => {
      setShowErrorMSg(false);
      setOpenTableTooltip(false);
      setGeoTableSelectAll(!geoTableSelectAll);
      if (rows.length > 0) setSelectedGeoRows(rows);
      else setSelectedGeoRows([]);
    },
    [geoTableSelectAll]
  );

  const getSelectedOpName = useMemo(() => {
    const op = permittedOperators.find(
      (x) => x.operator === selectedOperatorSupply
    );
    return op ? op.name : "Selected Operator";
  }, [operatorDetails, selectedOperatorSupply]);

  const getAdminlvlName = (key) => {
    switch (key) {
      case "ADM1":
        return globalConfig?.adminLevelLabels?.adm1 || "";
      case "ADM2":
        return globalConfig?.adminLevelLabels?.adm2 || "";
      case "ADM3":
        return globalConfig?.adminLevelLabels?.adm3 || "";
      default:
        break;
    }
  };

  const updateMSQuadName = (colorText) => {
    try {
      const quadItem = msConfig[0].content.find(item => item.type === 'quad');
      if (quadItem) {
        const value = quadItem.values.find(value => value.colorText === colorText);
        
        if (value) {
          return value.text;
        }
      }
      return colorText;
    } catch (error) {
      return colorText;
    }
  }

  const mappings = {
    avg_dbm: "Signal Strength",
    avg_upload: "Upload",
    avg_download: "Download",
    rsrq: "Signal Quality",
    sinr: "S/N Ratio"
  };
  const getMappedOrCapitalizedKey = key => mappings[key] || capitalizeFirstLetter(key);

  const units = {
    avg_dbm: "dBm",
    avg_upload: "Mbps",
    avg_download: "Mbps",
    rsrq: "dB",
    sinr: "dB",
    t_length: " m"
  };

  const decimals = {
    avg_dbm: 0,
    avg_upload: 2,
    avg_download: 2,
    rsrq: 0,
    sinr: 0
  };

  const keyMapping1 = {
    "t_roads": {
      label: "Total Roads",
      imgSrc:"/assets/Total Roads.png",
      imgAlt: "logo for total roads"
    },
    "t_length": {
      label: "Roads Length",
      imgSrc: "/assets/Roads Length.png",
      imgAlt: "logo for total length"
    },
    "pop": {
      label: "Population",
      imgSrc: "/assets/Population1.png",
      imgAlt: "logo for population"
    },
    "build_up": {
      label: "Buildup",
      imgSrc: "/assets/Buildup.png",
      imgAlt: "logo for build up"
    },
    "poi": {
      label: "POI",
      imgSrc: "/assets/POI.png",
      imgAlt: "logo for point of interest"
    }
  };

  
 const keyMapping2 = {
  "morphology": {
    label: "Total Geohash",
    imgSrc: "/assets/POI.png",
    imgAlt: "logo for total roads"
  },
  "d_urban": {
    label: "Dense Urban",
    imgSrc: "/assets/Dense Urban.png",
    imgAlt: "logo for total length"
  },
  "urban": {
    label: "Urban",
    imgSrc: "/assets/Urban.png",
    imgAlt: "logo for point of interest"
  },
  "s_urban": {
    label: "Suburban",
    imgSrc:  "/assets/Suburban.png",
    imgAlt: "logo for build up"
  },
  "rural": {
    label: "Rural",
    imgSrc: "/assets/Rural.png" ,
    imgAlt: "logo for population"
  },
};

const order = ["morphology","d_urban", "urban", "s_urban", "rural"];

  return (
    <>
      <ModalContainer ref={parentRef} isVisible={isOpen} skipWidth={getSidePanelWidth()} mapView={mapView} mapPlacement={mapPlacement}>
        <HeaderClose
          style={{
            position: "absolute",
            top: "-8px",
            right: "-6px",
            backgroundColor: "rgba(255, 255, 255, 1)",
            color: "white",
            width: "25px",
            height: "25px",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderColor: "black",
            paddingTop: "2px",
            cursor: "pointer",
            zIndex: 3000,
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.4)",
          }}
        >
          <div
            onClick={() => {
              setIsOpen(false);
              setIsOpMsTableOpen(false);
              setInitialGeohashes([]);
              if (!selectedGeoRows.length) {
                setMsGeohashOnMap(false);
                setVisualizePriority("divTable");
              }
              if (!selectedRows.length) setSavedRows([]);
              if (!selectedGeoRows.length) setSavedGeoRows([]);
            }}
          >
            <CloseRoundedIcon style={{ fontSize: "15px" }} color="action" />{" "}
          </div>
        </HeaderClose>
        <Grid container>
          <Grid container item xs={7} style={{ height: "100%", width: "100%" }}>
            <Grid
              item
              style={{
                width: "100%",
                padding: "2px",
                height: `${parentHeight / 2}px`,
                margin: "2px",
                border: "1px solid #ccc",
              }}
            >
              <CommonTitleBar
                title={`Details by ${getAdminlvlName(
                  borderLvlValue
                )} for ${getSelectedOpName}`}
              >
                <div
                  style={{
                    color: "white",
                    marginLeft: "5px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingRight: "5px",
                    borderRight: "1px solid rgb(176 172 172)",
                  }}
                  onClick={() => {
                    // reset & clear
                    setIsOpen(false);
                    setSelectedGeoRows([]);
                    setSelectedRows([]);
                    fetchCtAvailability(true);

                    // draw on map
                    setVisualizePriority("divTable");
                    setMsGeohashOnMap(false);
                    setSavedRows(selectedRows); // save selected rows to visualize on map
                  }}
                >
                  <StyleTooltip title={"Visualize on map"}>
                    <img
                      src={"/assets/mappin.png"}
                      style={{ width: "15px", height: "15px" }}
                      alt="Icon"
                    />
                  </StyleTooltip>
                </div>
                {selectedRows.length > 0 && <StyleTooltip title={"Clear selection"}>
                  <div
                    style={{
                      marginLeft: "5px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      paddingRight: "5px",
                      borderRight: "1px solid rgb(176 172 172)",
                  }}
                  >
                    <AiOutlineClear
                      style={{ cursor: "pointer", color: "white", fontSize: "18px" }}
                      onClick={() => {
                        setDiviTableClear(true);
                        setSavedRows([]);
                      }}
                    />
                  </div>
                </StyleTooltip>}
                <div
                  style={{
                    color: "white",
                    marginLeft: "5px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={onClickDownload}
                >
                  <StyleTooltip title={"Download CSV"}>
                    <img
                      src={"/assets/download2.png"}
                      style={{ width: "15px", height: "15px" }}
                      alt="Icon"
                    />
                  </StyleTooltip>
                </div>
              </CommonTitleBar>
              <CommonInfiniteScrollTable
                onFetchMoreData={fetchData}
                columns={filteredColumns}
                data={operatorTableData}
                onClickRow={onClickRow}
                onSelectRow={onSelectRow}
                onSelectAll={onSelectAll}
                initialFetch={diviTableInitFetch}
                onClearSelectedRows={() => clearSelectedData("DiviTable")}
                sorting={msSort}
                setSorting={(val) => setMsSort(val)}
                height={parentHeight / 2 - 40}
                parentDeselect={diviTableClear}
                setParentDeselect={setDiviTableClear}
              />

              {openTableTooltip && (
                <CommonTableTooltip
                  handleClose={() => {
                    setOpenTableTooltip(false);
                  }}
                  rowPosition={optTableTooltipData.rowPosition}
                  tableRef={optTableTooltipData.tablePosition}
                  title={`Market Share by ${getAdminlvlName(
                    borderLvlValue
                  )} for ${getSelectedOpName}`}
                >
                  <Grid container style={{ padding: '8px', paddingBottom: '0px', paddingTop: '0px', top: '-9px', left: '-4px' }} xs={12}>
                    <Grid item xs={7}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height:
                            window.devicePixelRatio >= 1.25 ? "26vh" : "20vh",
                            // marginTop: "15px",
                        }}
                      >
                        <CommonPieChart
                          data={optTableTooltipData?.data}
                          radius={[25, 37]}
                          percentage={true}
                          containerHeight={18}
                          containerWidth="60%"
                          arrows={false}
                          marginEnable={false}
                          onClick={(entry) => {
                            setOptTableTooltipData((prevData) => ({
                              ...prevData,
                              selectedOptr: entry,
                            }));
                          }}
                        />
                      </div>
                    </Grid>
                    <Grid
                      item
                      xs={5}
                      style={{
                        borderLeft: "1.5px dashed #70707030",
                        alignContent: "center",
                        // marginBottom: "10px",
                        // marginTop: "15px",


                        height: "180px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          padding: 5,
                        }}
                      >
                        {Object.entries(
                          optTableTooltipData?.selectedOptr?.details
                        ).map(([key, value]) => (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginTop: "8px",
                              marginBottom: "10px",
                            }}
                          >
                            <div style={{ alignItems: "left" }}>
                              {key === "avg_dbm" && (
                                <IconWrapper>
                                  <img
                                    src={"/assets/signal.png"}
                                    alt="logo1"
                                    width="13"
                                  />
                                </IconWrapper>
                              )}
                              {key === "avg_upload" && (
                                <IconWrapper>
                                  <img
                                    src={"/assets/upload.png"}
                                    alt="logo1"
                                    width="13"
                                  />
                                </IconWrapper>
                              )}
                              {key === "avg_download" && (
                                <IconWrapper>
                                  <img
                                    src={"/assets/download.png"}
                                    alt="logo1"
                                    width="13"
                                  />
                                </IconWrapper>
                              )}
                              {key === "rsrq" && (
                                <IconWrapper>
                                  <img
                                    src={"/assets/No Signal.png"}
                                    alt="logo1"
                                    width="13"
                                  />
                                </IconWrapper>
                              )}
                              {key === "sinr" && (
                                <IconWrapper>
                                  <img
                                    src={"/assets/sinrIcon.png"}
                                    alt="logo1"
                                    width="13"
                                  />
                                </IconWrapper>
                              )}
                            </div>
                            <div style={{
                              flex: '1', display: 'flex', justifyContent: 'space-between',
                            }}>
                              <div
                                style={{
                                  font: "normal normal 600 11px/12px Open Sans",
                                  opacity: "0.7",
                                  textAlign: "left"
                                }}
                              >
                                {key ? getMappedOrCapitalizedKey(key) : ""}
                              </div>
                              <div
                                style={{
                                  maxWidth: "80px",
                                  overflowWrap: "break-word",
                                  font: "normal normal 11px/12px 'Open Sans'",
                                  color: "black",
                                  // opacity: "0.7",
                                  textAlign: "right"
                                }}
                              >
                                {typeof value === "number" && value % 1 !== 0
                                  ? formatDecimalPoints(value, decimals[key]) + " " + units[key]
                                  : value || "N/A"}
                              </div></div>
                          </div>
                        ))}
                      </div>
                    </Grid>
                    <Divider
                      orientation="horizontal"
                      flexItem
                      style={{ width: "100%", position: "relative", top: "-5px" }}
                    />
                    <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', marginBottom: '5px' }} onClick={() => setIsExpanded(!isExpanded)}>

                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{
                          textAlign: 'left',
                          font: 'normal normal 600 11px/12px Open Sans',
                          letterSpacing: '0px',
                          fontWeight: 'bold',
                          color: '#000000',
                          opacity: 0.6,
                          alignItems: 'center',
                          marginLeft: '3px',
                          flex: 1,
                          marginRight: '8px',

                        }}>
                          {`Admin Level Details `}
                        </div>
                        {isExpanded ? (
                          <ArrowBackIosNewIcon style={{ transform: 'rotate(90deg)', fontSize: '16px', color: '#000000', opacity: 0.6, marginTop: '3px' }} />
                        ) : (
                          <ArrowForwardIosIcon style={{ transform: 'rotate(90deg)', fontSize: '16px', color: '#000000', opacity: 0.6, marginTop: '3px' }} />
                        )}
                      </div>
                    </Grid>



                    {isExpanded && (
                      <Grid container >

                        <Grid item xs={6}>
                          <div>
                          {Object.entries(optTableTooltipData?.admData || {}).slice(0, 5).map(([key, value]) => {
  const mappedKey = keyMapping1[key];
  const displayLabel = mappedKey ? mappedKey.label : key; // Fallback to the original key if no mapping found
  const imgSrc = mappedKey ? mappedKey.imgSrc : null;
  const imgAlt = mappedKey ? mappedKey.imgAlt : null;

  // Determine if a percentage mark should be added
  const shouldAppendPercentage = key === "build_up"; // Check if the current key is "build_up"
  let displayValue = value;
  if (typeof value === "number") {
    displayValue = value.toLocaleString(undefined, { minimumFractionDigits: value % 1 !== 0 ? 2 : 0 }) + `${units[key] ? units[key] : ""}`;
    if (shouldAppendPercentage) {
      displayValue += ' %'; // Append '%' if the key is "build_up"
    }
  } else {
    displayValue = value || "N/A";
  }

  return (
    <div key={key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '8px', marginBottom: '8px' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          font: "normal normal 600 11px/12px Open Sans",
          opacity: "0.7",
          textAlign: "left",
          marginRight: '10px',
        }}
      >
        {imgSrc && <img src={imgSrc} alt={imgAlt} width="13" style={{ marginRight: '5px' }} />}
        {displayLabel}
      </div>
      <div
        style={{
          maxWidth: "80px",
          overflowWrap: "break-word",
          font: `normal normal ${typeof value === "number" ? "normal" : "600"} 11px/12px Open Sans`,
          opacity: typeof value === "number" ? "1" : "0.7",
          color: typeof value === "number" ? "black" : "",
          textAlign: "right",
        }}
      >
        {displayValue}
      </div>
    </div>
  );
})}

                          </div>
                        </Grid>
                        <Grid item xs={6}>
                          <div style={{ margin: 10, borderLeft: "1.5px dashed #70707030", height: "80%",marginRight: "5px",paddingLeft:"5px" }}>

                          {order.map((key) => {
  const value = optTableTooltipData?.admData?.[key] ?? ""; // Get the value using the ordered key
  const mappedKey = keyMapping2[key];
  const displayLabel = mappedKey ? mappedKey.label : key; // Fallback to the original key if no mapping found
  const imgSrc = mappedKey ? mappedKey.imgSrc : null;
  const imgAlt = mappedKey ? mappedKey.imgAlt : null;

  // Determine if a percentage mark should be added
  const shouldAppendPercentage = ["d_urban", "urban", "s_urban", "rural"].includes(key);
  let displayValue = value;
  if (typeof value === "number") {
    displayValue = value.toLocaleString(undefined, { minimumFractionDigits: value % 1 !== 0 ? 2 : 0 });
    if (shouldAppendPercentage) {
      displayValue += ' %'; // Append '%' if the key matches the condition
    }
  } else {
    displayValue = value || "N/A";
  }

  return (
    <div key={key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '8px', marginBottom: '8px' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          font: "normal normal 600 11px/12px Open Sans",
          opacity: "0.7",
          textAlign: "left",
          marginRight: '10px',
        }}
      >
        {imgSrc && <img src={imgSrc} alt={imgAlt} width="13" style={{ marginRight: '5px' }} />}
        {displayLabel}
      </div>
      <div
        style={{
          maxWidth: "80px",
          overflowWrap: "break-word",
          font: `normal normal ${typeof value === "number" ? "normal" : "600"} 11px/12px Open Sans`,
          opacity: typeof value === "number" ? "1" : "0.7",
          color: typeof value === "number" ? "black" : "",
          textAlign: "right",
        }}
      >
        {displayValue}
      </div>
    </div>
  );
})}

                          </div>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </CommonTableTooltip>
              )}
            </Grid>
            <Grid
              item
              style={{
                width: "100%",
                padding: "2px",
                height: `${parentHeight / 2 - 20}px`,
                margin: "2px",
                border: "1px solid #ccc",
              }}
            >
              <CommonTitleBar title={"Trend of % of Good Samples"} />

              <Grid container spacing={1}>
                <Grid item xs={6} style={{

                  marginBottom: "10px",
                }}>
                  <Grid
                    container
                    spacing={1}
                    direction="row"
                    style={{
                      marginTop: "10px",
                      marginBottom: "12px",
                      alignItems: "center"
                    }}
                  >
                    {" "}
                    <ColorDot
                      label="Signal Strength"
                      color="#FFBF00"
                      borderColor="#d49f02"
                    />
                    <ColorDot
                      label="Download"
                      color="#39FF14"
                      borderColor="#2ecf11"
                    />
                    <ColorDot
                      label="Upload"
                      color="#15F4EE"
                      borderColor="#12c9c5"
                    />
                  </Grid>
                  <Grid
                    style={{
                      margin: "10px",
                      width: trendTabs.length === 1 ? "100px" : "auto"
                    }}
                  >
                    <CommonTypeTabsGroup
                      data={trendTabs}
                      value={selectedTab}
                      handleChange={handleTabChange}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={6} style={{ marginTop: "2px" }}>
                  <BasicDatePicker
                    onDateChange={handleDateChange}
                    selectedTab={selectedTab}
                    year={year}
                    quarter={quarter}
                  />
                </Grid>{" "}
              </Grid>
              <CustomDiv>
                {isVisibleOverlay && !isLoading && <div
                  style={{
                    width: "100%",
                    backgroundColor: "white",
                    height: "100%",
                    opacity: "0.7",
                    zIndex: '9',
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontFamily: 'Open Sans',
                    fontSize: '12px'
                  }}
                >
                  <div>{selectedTab ? `No ${selectedTab} Trend Data Available` : " "}</div>
                </div>}
                {!isVisibleOverlay && !isLoading && <CommonTimeLineChart data={trendsData} type={selectedTab} />}
              </CustomDiv>
            </Grid>
          </Grid>
          <Grid container item xs={5} style={{ height: "100%" }}>
            <Grid
              item
              style={{
                width: "100%",
                height: `${parentHeight / 2}px`,
                display: "flex",
                marginBottom: "4px",
                paddingBottom: "2px",
              }}
            >
              <Grid
                item
                style={{
                  flexBasis: "50%",
                  marginLeft: "2px",
                }}
              >
                <Grid
                  item
                  style={{
                    padding: "2px",
                    margin: "2px",
                    border: "1px solid #ccc",
                    height: `${(parentHeight / 2) * 0.75}px`,
                  }}
                >
                  <CommonTitleBar
                    title={`Nationwide Market Share (${connectionValue} Subs)`}
                  />
                  <div
                    style={{ height: `${(parentHeight / 2) * 0.75 - 30}px` }}
                  >
                    <CommonPieChart
                      data={nationPieData}
                      radius={[25, 37]}
                      percentage={true}
                      arrows={true}
                    />
                  </div>
                </Grid>
                <Grid
                  item
                  style={{
                    padding: "2px",
                    margin: "2px",
                    border: "1px solid #ccc",
                    height: `${(parentHeight / 2) * 0.242}px`,
                    marginBottom: "2px",
                  }}
                >
                  <CommonTitleBar title={`${connectionValue} Availability`} />
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: `${(parentHeight / 2) * 0.242 - 40}px`,
                    }}
                  >
                    <h3>{`${msAvailability || ""}%` || "N/A"}</h3>
                  </div>
                </Grid>
              </Grid>
              <Grid
                item
                style={{
                  width: "100%",
                  height: `${parentHeight / 2}px`,
                  overflowX: "auto",
                  padding: "2px",
                  margin: "2px",
                  border: "1px solid #ccc",
                  flexBasis: "50%",
                }}
              >
                <CommonTitleBar title={`Market Share Vs Network Performance`} />
                <div
                  onClick={handleModalOpen}
                  style={{
                    cursor: "pointer",
                    paddingLeft: "2px",
                  }}
                >
                  <CommonScatterChart
                    width={parentWidth / 5 - 11}
                    height={parentHeight / 2 - 75}
                    margin={{ top: 20, right: 30, bottom: 20, left: 40 }}
                    data={scatterData}
                    r={1}
                    ADM={borderLvlValue}
                    yRefLine={yRefLine}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid
              item
              style={{
                overflowX: "auto",
                padding: "2px",
                width: "100%",
                height: `${parentHeight / 2 - 20}px`,
                margin: "2px",
                border: "1px solid #ccc",
              }}
            >
              <CommonTitleBar title={"Details of Geohash"}>
                <div
                  style={{
                    color: "white",
                    marginLeft: "5px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingRight: "5px",
                    borderRight: "1px solid rgb(176 172 172)",
                  }}
                  onClick={() => {
                    // reset & clear
                    setIsOpen(false);
                    setSelectedGeoRows([]);
                    setSelectedRows([]);
                    fetchCtAvailability(true);

                    // draw on map
                    setVisualizePriority("geoTable");
                    if (!selectedGeoRows.length) setMsGeohashOnMap(true); // draw all geohashes on map
                    else setMsGeohashOnMap(false);

                    setSavedGeoRows(selectedGeoRows); // save selected geo rows to display on map
                    setSavedRows(selectedRows);
                  }}
                >
                  <StyleTooltip title={"Visualize on map"}>
                    <img
                      src={"/assets/mappin.png"}
                      style={{ width: "15px", height: "15px" }}
                      alt="Icon"
                    />
                  </StyleTooltip>
                </div>
                {selectedGeoRows.length > 0 && <StyleTooltip title={"Clear selection"}>
                  <div
                    style={{
                      marginLeft: "5px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      paddingRight: "5px",
                      borderRight: "1px solid rgb(176 172 172)",
                  }}
                  >
                    <AiOutlineClear
                      style={{ cursor: "pointer", color: "white", fontSize: "18px" }}
                      onClick={() => {
                        setGeoTableClear(true);
                        setSavedGeoRows([]);
                      }}
                    />
                  </div>
                </StyleTooltip>}
                <div
                  style={{
                    color: "white",
                    marginLeft: "5px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={onClickGeohashDownload}
                >
                  <StyleTooltip title={"Download CSV"}>
                    <img
                      src={"/assets/download2.png"}
                      style={{ width: "15px", height: "15px" }}
                      alt="Icon"
                    />
                    {/* <SaveAltIcon style={{ fontSize: "17px" }} /> */}
                  </StyleTooltip>
                </div>
                {geoHashloading && (
                  <StyleTooltip
                    title="Downloading..."
                    fontColor="green"
                    open={true}
                  >
                    <CircularProgress
                      size="1rem"
                      style={{ color: "white", marginLeft: "7px" }}
                    />
                  </StyleTooltip>
                )}
                {showErrorMsg && (
                  <StyleTooltip
                    title="To Downlaod, select ADM level 3"
                    fontColor="red"
                    open={true}
                  >
                    <img
                      src={"/assets/error.png"}
                      alt="eror"
                      width="17px"
                      height="17px"
                      style={{ marginLeft: "7px" }}
                    />
                  </StyleTooltip>
                )}
                {maxSizeExeeds && (
                  <StyleTooltip
                    title="Maximum size exceeded. Only partial data will be downloaded."
                    fontColor="orange"
                    open={true}
                  >
                    <img
                      src={"/assets/alert.png"}
                      alt="warning"
                      width="18px"
                      height="18px"
                      style={{ marginLeft: "7px" }}
                    />
                  </StyleTooltip>
                )}
              </CommonTitleBar>
              <CommonInfiniteScrollTable
                onFetchMoreData={fetchGeohashData}
                columns={geohashfilteredColumns}
                data={getUniqueGeohashes(geohashTableData)}
                onSelectRow={onSelectGeohashRow}
                onSelectAll={onSelectGeohashAll}
                initialFetch={geoTableInitFetch}
                customPage={customGeoPage}
                setCustomPage={(page) => setCustomGeoPage(page)}
                onClearSelectedRows={() => clearSelectedData("GeohashTable")}
                sorting={geoMsSort}
                setSorting={(val) => setGeoMsSort(val)}
                height={parentHeight / 2 - 62}
                parentDeselect={geoTableClear}
                setParentDeselect={setGeoTableClear}
              />
            </Grid>
          </Grid>
        </Grid>
      </ModalContainer>
      {isModalOpen && (
        <ScatterModal
          isOpen={isModalOpen}
          setIsOpen={handleModalClose}
          scatterData={scatterData}
          yRefLine={yRefLine}
          ADM={borderLvlValue}
          quadCount={quadCount}
        />
      )}
    </>
  );
};

export default OprtMSModal;
